var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
let MenubarPathStepButton = class MenubarPathStepButton extends React.PureComponent {
    get appWidth() {
        return this.props.step.app.appMeasure.appWidthInPixel;
    }
    get fontFamily() {
        if (this.appWidth < 1200)
            return "'Roboto Condensed',sans-serif";
        return "'Roboto',sans-serif";
    }
    get label() {
        const { step } = this.props;
        if (step.location && step.location.type === 'topic') {
            return React.createElement("h1", { style: { color: '#9d9d9d', fontSize: 15, margin: 0, marginRight: 3 } }, step.label);
        }
        return React.createElement("span", null, step.label);
    }
    get paddingLeftRight() {
        if (this.appWidth < 1200)
            return 5;
        if (this.appWidth < 1400)
            return 10;
        return 15;
    }
    get addClassName() {
        if (this.props.step.isNeighbourMenuOpen) {
            return 'PathStepButtonOpen';
        }
        return '';
    }
    render() {
        const { step } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { className: `${this.addClassName}`, onClick: step.handleStepButtonClick, style: {
                    fontSize: 15,
                    display: 'flex',
                    alignItems: 'center',
                    height: 45,
                    paddingBottom: 12,
                    paddingTop: 11,
                    textShadow: '0 -1px 0 rgba(0,0,0,0.25)',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    color: '#9d9d9d',
                    paddingLeft: this.paddingLeftRight,
                    paddingRight: this.paddingLeftRight,
                    fontFamily: this.fontFamily,
                }, onMouseEnter: action(() => (step.isStepButtonHovering = true)), onMouseLeave: action(() => (step.isStepButtonHovering = false)) },
                this.label,
                React.createElement("span", { style: { marginLeft: 5, fontSize: 11, transform: 'scale(1, 0.6)' } }, "\u25BC")),
            this.pathStepMenu));
    }
    get pathStepMenu() {
        const { step } = this.props;
        if (!runtime.availablePackages.Lazy)
            return null;
        const { MenubarPathStepMenu } = runtime.availablePackages.Lazy.components;
        return React.createElement(MenubarPathStepMenu, { step: step });
    }
};
MenubarPathStepButton = __decorate([
    observer
], MenubarPathStepButton);
export { MenubarPathStepButton };
